/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiArtifactFromJSON, StreemApiArtifactToJSON, } from './';
export function StreemApiGetLayoutEstimationResponseFromJSON(json) {
    return StreemApiGetLayoutEstimationResponseFromJSONTyped(json, false);
}
export function StreemApiGetLayoutEstimationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'layoutEstimationArtifact': !exists(json, 'layout_estimation_artifact') ? undefined : StreemApiArtifactFromJSON(json['layout_estimation_artifact']),
    };
}
export function StreemApiGetLayoutEstimationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'layout_estimation_artifact': StreemApiArtifactToJSON(value.layoutEstimationArtifact),
    };
}
//# sourceMappingURL=StreemApiGetLayoutEstimationResponse.js.map